import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./ListLink.module.css";

/**
 * Navigation-drawer list item styled per MD3 navigation-drawer specs.
 *
 * Renders as `<li>` wrapping a polymorphic inner element (button, anchor,
 * or a router link component passed via `as`).
 *
 * For react-router integration, pass `as={NavLink}` with
 * `activeClassName={ListLink.activeClassName}` so the active route receives
 * the correct visual treatment.
 */
const ListLink = React.forwardRef(
  (
    {
      as: Component = "button",
      leading,
      trailing,
      className,
      children,
      ...rest
    },
    ref,
  ) => {
    const buttonProps = Component === "button" ? { type: "button" } : {};

    return (
      <li className={css.wrapper}>
        <Component
          ref={ref}
          className={clsx(css.link, className)}
          {...buttonProps}
          {...rest}
        >
          {leading && <span className={css.leading}>{leading}</span>}
          <span className={css.label}>{children}</span>
          {trailing && <span className={css.trailing}>{trailing}</span>}
        </Component>
      </li>
    );
  },
);

ListLink.displayName = "ListLink";

/**
 * CSS class name for the active state. Pass this to NavLink's
 * `activeClassName` prop to highlight the current route.
 */
ListLink.activeClassName = css.active;

ListLink.propTypes = {
  as: PropTypes.elementType,
  leading: PropTypes.node,
  trailing: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ListLink;
